import { Map, List } from 'immutable';
import { LOADING_STATUS } from '@dbh/generic-redux-constants';
import { REQUEST_QUEUE_STATUS_CHANGED, REQUEST_QUEUE_CLEARED, REQUEST_QUEUED } from './index.js';
export { REDUX_AND_SAGA_KEY } from './index.js';
import '@dbh/redux-saga-extra';
import '@dbh/request';
import '@dbh/with-conforms-to-for-production-www';
import 'react';
import 'prop-types';
import '@dbh/sentry';
import '@dbh/front-end-api-calls-logs';
import '@dbh/create-use-bound-event-creator';
import '@dbh/request-types';
import 'redux-saga/effects';
import '@dbh/redux-extra';
import '@dbh/environment';
import 'lodash/isEmpty';
import '@dbh/throw-in-server-side-rendering';
import 'reselect';
import '@dbh/api-constants';

const initialState=Map({requests:List(),status:LOADING_STATUS.NONE});function requestQueueReducer(a,b){void 0===a&&(a=initialState);const{type:c}=b;switch(c){case REQUEST_QUEUED:{const{payload:{apiUrl:c,options:d}}=b;// Don't transform values into immutable for performance reasons.
return a.update("requests",a=>a.push([c,d]))}case REQUEST_QUEUE_CLEARED:return a.merge(initialState);case REQUEST_QUEUE_STATUS_CHANGED:{const{payload:{status:c}}=b;return a.set("status",c)}default:return a}}

export { requestQueueReducer as default };
